// Central SKU registry (backend car_type_insurance_sku.json) as [{ value: 'CT1', sku_codes: [...] }].
function isValidCarTypeSkuList(list) {
  return Array.isArray(list) && list.length > 0 && list.every(
    (item) => item && typeof item.value === 'string' && Array.isArray(item.sku_codes)
  );
}

function getSkuCompatibility(carTypeSkuList, loaded, carType, skuCode) {
  if (!loaded || !Array.isArray(carTypeSkuList) || !skuCode) return 'unavailable';

  const config = carTypeSkuList.find((item) => item.value === carType);
  // A CT missing from the registry has no restriction, matching the existing flow.
  if (!config || config.sku_codes.length === 0) return 'unrestricted';
  return config.sku_codes.includes(skuCode) ? 'compatible' : 'incompatible';
}

function isSkuMismatchForCarType(carTypeSkuList, loaded, carType, skuCode, carFuel) {
  const entry = loaded && Array.isArray(carTypeSkuList) && carTypeSkuList.find(row => row.value === carType);
  if (entry && entry.recommendation) return classifySku(carTypeSkuList, loaded, carType, skuCode, carFuel) === 'OTHER';
  return getSkuCompatibility(carTypeSkuList, loaded, carType, skuCode) === 'incompatible';
}

function classifySku(list, loaded, carType, skuCode, carFuel) {
  const entry = loaded && Array.isArray(list) && list.find(row => row.value === carType);
  const rule = entry && entry.recommendation;
  if (!rule || !Object.keys(rule).length || rule.unverified) return 'SPECIAL';
  const recommended = (rule.fuel_recommended || {})[String(carFuel)] || rule.recommended || [];
  if (recommended.includes(skuCode)) return 'RECOMMENDED';
  if ((rule.special || []).includes(skuCode)) return 'SPECIAL';
  return 'OTHER';
}

function sortSkuCatalogue(products, list, loaded, carType, carFuel) {
  const rank = { RECOMMENDED: 0, SPECIAL: 1, OTHER: 2 };
  return products.map((product, index) => ({ product, index })).sort((a, b) => {
    const group = rank[classifySku(list, loaded, carType, a.product.sku_code, carFuel)] -
      rank[classifySku(list, loaded, carType, b.product.sku_code, carFuel)];
    const left = a.product.sku_code || '', right = b.product.sku_code || '';
    return group || (left < right ? -1 : left > right ? 1 : a.index - b.index);
  }).map(row => row.product);
}

function isSkuAutoSelectableForCarType(carTypeSkuList, loaded, carType, skuCode, carFuel) {
  if (carType === 'CT1' && Number(carFuel) === 3) {
    return loaded && skuCode === '1.10E';
  }
  const compatibility = getSkuCompatibility(carTypeSkuList, loaded, carType, skuCode);
  return compatibility === 'compatible' || compatibility === 'unrestricted';
}

module.exports = {
  classifySku,
  sortSkuCatalogue,
  isValidCarTypeSkuList,
  getSkuCompatibility,
  isSkuMismatchForCarType,
  isSkuAutoSelectableForCarType,
};
